export class count_down_timer_controller {
    time: any;
    constructor() {
        "ngInject"
    }

    $onInit() {
       
    }
   
}


// WEBPACK FOOTER //
// ./src/components/count-down-timer/count-down-timer.controller.ts